<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Situação financeira e patrimonial'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Dados Financeiros'"
                        :SubSessao="'Situação Financeira e Patrimonial'" />
                    <span>
                        As informações a seguir devem ser compatíveis com seus investimentos e a sua capacidade
                        financeira e patrimonial, conforme definido na regulamentação vigente.
                    </span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Remuneração mensal</label>
                            <input class="field" type="text" v-model="localPF.RemuneracaoMensal" id="RemuneracaoMensal"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('RemuneracaoMensal')"
                                @focus="() => focusIn('RemuneracaoMensal')"
                                @input="event => handleInput(event, 'RemuneracaoMensal')">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 75%">
                            <label class="label" for="nome">Outros rendimentos</label>
                            <div class="radioDadosFinanceiros">
                                <input type="radio" id="Base anual" value="Base anual" name="BaseOutrosRendimentos"
                                    class="field__radio" v-model="localPF.BaseOutrosRendimentos"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Base anual
                                </label>
                                <input type="radio" id="Base mensal" value="Base mensal" name="BaseOutrosRendimentos"
                                    class="field__radio" v-model="localPF.BaseOutrosRendimentos"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Base mensal
                                </label>
                                <input class="field" type="text" v-model="localPF.OutrosRendimentos"
                                    id="OutrosRendimentos" @change="salvarAlteracoesLocalmente"
                                    @blur="() => focusOut('OutrosRendimentos')"
                                    @focus="() => focusIn('OutrosRendimentos')"
                                    @input="event => handleInput(event, 'OutrosRendimentos')">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente"
                                v-model="localPF.OutrosRendimentosEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Bens imóveis*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.BensImoveis" id="BensImoveis"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('BensImoveis')"
                                @focus="() => focusIn('BensImoveis')"
                                @input="event => handleInput(event, 'BensImoveis')">
                            <p v-if="camposObrigatorios.erroBensImoveis" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPF.BensImoveisEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Bens móveis*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.BensMoveis" id="BensMoveis"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('BensMoveis')"
                                @focus="() => focusIn('BensMoveis')" @input="event => handleInput(event, 'BensMoveis')">
                            <p v-if="camposObrigatorios.erroBensMoveis" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea v-model="localPF.BensMoveisEspecificacao" @change="salvarAlteracoesLocalmente"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field">
                            <label class="label" for="nome">Patrimônio líquido em aplicações financeiras*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.PatrimonioLiquido" id="PatrimonioLiquido"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('PatrimonioLiquido')"
                                @focus="() => focusIn('PatrimonioLiquido')"
                                @input="event => handleInput(event, 'PatrimonioLiquido')">
                            <p v-if="camposObrigatorios.erroPatrimonioLiquido" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente"
                                v-model="localPF.PatrimonioLiquidoEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field">
                            <label class="label" for="nome">Patrimônio total estimado</label>
                            <input class="field" type="text" v-model.lazy="localPF.PatrimonioTotal"
                                @change="salvarAlteracoesLocalmente" id="PatrimonioTotal" :disabled="true">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VMoney } from 'v-money'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import { formatCurrency, parseCurrency, parseCurrencyToNumber, handleInput } from '@/utils/formUtils';
export default {
    directives: {
        money: VMoney
    },
    name: 'CadastroPF_DadosFinanceiros',
    props: ['informacoesFinanceiras', 'Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
        }),
        formattedPatrimonioTotal() {
            return formatCurrency(this.calculatePatrimonioTotal());
        }
    },
    data() {
        return {
            permitirAvancar: true,
            localPF: this.informacoesFinanceiras,
            opcoesDeMoeda: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2
            },
            bensImoveis: 0,
            bensMoveis: 0,
            patrimonioLiquido: 0,
            patrimonioTotal: 0,
            camposObrigatorios: {
                erroBensImoveis: false,
                erroBensMoveis: false,
                erroPatrimonioLiquido: false,
            }
        }
    },
    mounted() {
        this.updatePatrimonioTotal();
    },
    watch: {
        'localPF.BensImoveis': 'updatePatrimonioTotal',
        'localPF.BensMoveis': 'updatePatrimonioTotal',
        'localPF.PatrimonioLiquido': 'updatePatrimonioTotal',
    },
    methods: {
        updatePatrimonioTotal() {
            const total = this.calculatePatrimonioTotal();
            this.localPF.PatrimonioTotal = formatCurrency(total);
        },
        calculatePatrimonioTotal() {
                // Usa o parser já existente; se vier vazio/ inválido, considera 0
                const toNum = (v) => {
                    const n = parseCurrencyToNumber(v);
                    return Number.isFinite(n) ? n : 0;
                };

                const total =
                    toNum(this.localPF.BensImoveis) +
                    toNum(this.localPF.BensMoveis) +
                    toNum(this.localPF.PatrimonioLiquido);

                return total;
        },
        async validarFormulario(submeter) {
            // use variável local para evitar efeitos colaterais
            let permitirAvancar = true;
            let nomeDoCampo = '';

            // zera flags
            this.camposObrigatorios = {
                erroBensImoveis: false,
                erroBensMoveis: false,
                erroPatrimonioLiquido: false,
            };

            const checks = [
                { key: 'BensImoveis',        label: 'Bens imóveis',        flag: 'erroBensImoveis' },
                { key: 'BensMoveis',         label: 'Bens móveis',         flag: 'erroBensMoveis' },
                { key: 'PatrimonioLiquido',  label: 'Patrimônio líquido',  flag: 'erroPatrimonioLiquido' },
            ];

            for (const c of checks) {
                const ok = this.isNumeroValidoObrigatorio(c.key);
                if (!ok) {
                if (submeter && permitirAvancar) {
                    this.camposObrigatorios[c.flag] = true;
                    nomeDoCampo = c.label;
                }
                permitirAvancar = false;
                }
            }

            if (submeter && nomeDoCampo) {
                await this.$swal({
                icon: 'warning',
                title: 'Oops...',
                text: `O campo ${nomeDoCampo} não foi informado corretamente. Use um valor numérico (pode ser 0).`,
                });
            }

            if (!permitirAvancar) return false;

            // (opcional) Confirmar se todos os três foram preenchidos como zero
            const todosZero =
                parseCurrencyToNumber(this.localPF.BensImoveis) === 0 &&
                parseCurrencyToNumber(this.localPF.BensMoveis) === 0 &&
                parseCurrencyToNumber(this.localPF.PatrimonioLiquido) === 0;

            if (submeter && todosZero) {
                return await this.$swal({
                    icon: 'question',
                    title: 'Confirma os valores?',
                    text: 'Todos os valores obrigatórios foram preenchidos como R$ 0,00. Tem certeza de que deseja continuar?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, continuar',
                    cancelButtonText: 'Não, voltar',
                    }).then(result => {
                    return result.isConfirmed;
                    });
            }

            return true;
            },
        async proximaEtapa() {
            if (await this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 3);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_FINANCEIRAS', this.localPF);
        },
        focusOut(fieldName) {
            const n = parseCurrencyToNumber(this.localPF[fieldName]);
            this.localPF[fieldName] = n !== null ? formatCurrency(n) : '';
        },
        parseToNumber(value) {
            const parsed = parseCurrency(value);

            // aqui não pode usar if (!parsed), pois 0 é falsy
            if (parsed === '' || parsed === null || parsed === undefined) return null;

            const n = Number(parsed);
            return Number.isFinite(n) ? n : null;
        },
        isNumeroValidoObrigatorio(fieldName) {
            const n = parseCurrencyToNumber(this.localPF[fieldName]);
            return n !== null && n >= 0;
        },
        focusIn(fieldName) {
            const value = this.localPF[fieldName];
            this.localPF[fieldName] = parseCurrency(value) ? parseCurrency(value).replace('.', '') : '';
        },
        handleInput(event, fieldName) {
            const inputValue = event.target.value;
            this.localPF[fieldName] = handleInput(inputValue);
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

// .formulario {
//     width: 100%;
// }
// .agrupamentoFormulario {
//     width: 100%;
//     display: inline-flex;
//     margin-top: 10px;
// }
// .categoriaAgrupamentoFormulario {
//     width: 13%;
//     margin-right: 15px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     span {
//         font-weight: 400 !important;
//         font-size: 13px;
//         color: #667085;
//     }
// }
// .label__field {
//     padding-right: 30px;
// }
.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .radioDadosFinanceiros {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field {
            width: 25% !important;
        }

        .field__radio {
            margin-top: -2px;
            width: 15px;
            height: 15px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #ffffff;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
            width: 10% !important;
        }
    }

    label {
        width: 100%;
    }

    .sub-label {
        width: 100%;
    }
}

// .title {
//     border-bottom: 1px solid #EAECF0;
//     h3 {
//         margin-top: 50px;
//         color: #101828;
//         font-weight: 500;
//         font-family: 'Inter', sans-serif;
//     }
//     h5 {
//         margin-top: 5px;
//         margin-block-start: 0;
//         color: #667085;
//         font-weight: 400;
//         font-family: 'Inter', sans-serif;
//     }
// }</style>